import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	DniZaokrPar: null as string | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	ProvozovnaId: null as number | null,
	PujcovnaId: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	Text: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrazenDat: null as Date | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.PUJCOVNA_VOZIDEL_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
